import TextInput from 'components/TextInput/TextInput';
import React, { useState } from 'react';
import './TieredCharge.scss';
import { formatCurrency, unFormatCurrency, unFormatPercent } from 'utils';
import Checkbox from 'components/Checkbox/Checkbox';
import { Button } from 'components/Base';
import Icons from 'components/Icons';
import { useDebouncedCallback } from 'use-debounce';
import { chargeTypes } from 'components/ProviderPlatformCharges/ProviderPlatformChargesComponent';
import { PlatformProviderChargeType } from 'components/ProviderPlatformCharges/types';
import { formatPercent } from 'utils/percent';
import { save } from 'components/ProviderPlatformCharges/util';
import { Grid } from '@material-ui/core';

type TieredChargeProps = {
  tieredChargeData: PlatformProviderChargeType | any;
  currentPolicyTypes: number[];
  updateCharge: Function;
  index: number;
  isFamilyLinked: boolean;
  checkForm: Function;
  selectedPlatformType: any;
  selectedProviderType: any;
  platformIndex: number;
  aumRangeFrom: string;
  aumRangeTo: string;
  isFirmAdmin: boolean;
  getRangeString: Function;
};

const TieredCharge: React.FC<TieredChargeProps> = ({
  tieredChargeData,
  currentPolicyTypes,
  updateCharge,
  isFamilyLinked,
  checkForm,
  selectedPlatformType,
  selectedProviderType,
  platformIndex,
  aumRangeFrom,
  aumRangeTo,
  isFirmAdmin,
  getRangeString
}) => {
  const [chargeValueTypeEnum, setChargeValueType] = useState(
    !!tieredChargeData && !!tieredChargeData.charge_value_type
      ? tieredChargeData.charge_value_type
      : 1
  );
  const [currentTieredChargeData, setCurrentTieredChargeData] = useState(
    tieredChargeData.tiered_charge
  );

  const updateStepField = (type: string, index: number, e: string) => {
    const tieredCharges = currentTieredChargeData;
    const chargeIndex = type === 'from' ? 0 : 1;
    tieredCharges[index][chargeIndex] = Number(unFormatCurrency(e));
    if (index !== 0 && type === 'from') {
      tieredCharges[index - 1][1] = Number(unFormatCurrency(e));
    }
    if (index !== currentTieredChargeData.length - 1 && type === 'to') {
      tieredCharges[index + 1][0] = Number(unFormatCurrency(e));
    }

    setCurrentTieredChargeData([...tieredCharges]);
  };

  const updateTierChargeField = (type: string, index: number, e: string) => {
    const tieredCharges = currentTieredChargeData;
    if (type === 'percentage') {
      tieredCharges[index][2] = Number(unFormatPercent(e)) / 100;
    } else {
      tieredCharges[index][2] = Number(unFormatCurrency(e));
    }
    setCurrentTieredChargeData([...tieredCharges]);
  };

  const addSteppedCharge = () => {
    setCurrentTieredChargeData([
      ...currentTieredChargeData,
      currentTieredChargeData.length === 0
        ? [0, null, null]
        : [null, null, null]
    ]);
  };
  const deleteSteppedCharge = (index: number) => {
    const tieredCharges = currentTieredChargeData;
    tieredCharges.splice(index, 1);
    setCurrentTieredChargeData([...tieredCharges]);
  };

  const changeChargeValueType = useDebouncedCallback(() => {
    const tieredChargeData = currentTieredChargeData;
    if (chargeValueTypeEnum === 2) {
      tieredChargeData.forEach((tcd: any) => {
        if (!!tcd && !!tcd[2]) tcd[2] = tcd[2] * 100;
      });
      setChargeValueType(1);
    } else {
      tieredChargeData.forEach((tcd: any) => {
        if (!!tcd && !!tcd[2]) tcd[2] = tcd[2] / 100;
      });
      setChargeValueType(2);
    }
    setCurrentTieredChargeData([...tieredChargeData]);
  });

  return (
    <div style={{ marginTop: '1rem' }}>
      <div style={{ marginBottom: '1rem' }}>
        <span style={{ fontWeight: 'bold' }}>
          {
            chargeTypes[
              tieredChargeData.charge_type as keyof typeof chargeTypes
            ]
          }{' '}
          Charge Band{' '}
        </span>
      </div>
      {isFirmAdmin && (
        <div className="chargeValueTypes">
          <Checkbox
            onClick={changeChargeValueType}
            label={'Percentage'}
            isChecked={chargeValueTypeEnum === 2}
          />
          <Checkbox
            onClick={changeChargeValueType}
            label={'Monetary'}
            isChecked={chargeValueTypeEnum === 1}
          />
        </div>
      )}
      <>
        {!isFirmAdmin && (
          <Grid
            container
            style={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}
          >
            <Grid item xs={7}>
              Range
            </Grid>
            <Grid item xs={5}>
              Charge value
            </Grid>
          </Grid>
        )}
        {currentTieredChargeData.map((scd: number[], index: number) => {
          const toValue = scd[0] ? formatCurrency(scd[0].toString()) : '£0.00';
          const fromValue = scd[1] ? formatCurrency(scd[1].toString()) : '';
          return (
            <div className={`steppedCharge`} key={`${scd[0]}__${index}`}>
              {isFirmAdmin ? (
                <>
                  <div style={{ width: '100px' }}>
                    <TextInput
                      label="From"
                      onChange={(e: string) =>
                        updateStepField('from', index, e)
                      }
                      value={toValue}
                      style={{
                        marginTop: '0.3rem',
                        marginBottom: '0.25rem',
                        width: 'max-content'
                      }}
                      formatter={formatCurrency}
                    />
                  </div>
                  <div style={{ width: '100px' }}>
                    <TextInput
                      label="To"
                      onChange={(e: string) => updateStepField('to', index, e)}
                      value={fromValue}
                      style={{
                        marginTop: '0.3rem',
                        marginBottom: '0.25rem',
                        width: 'max-content'
                      }}
                      formatter={formatCurrency}
                    />
                  </div>
                  <div style={{ width: '100px' }}>
                    {chargeValueTypeEnum === 2 && (
                      <TextInput
                        formatter={formatPercent}
                        label="Charge value"
                        onChange={(e: any) =>
                          updateTierChargeField('percentage', index, e)
                        }
                        value={scd[2] ? formatPercent(scd[2] * 100) : ''}
                        style={{
                          marginTop: '0.23rem',
                          marginBottom: '0.25rem'
                        }}
                      />
                    )}
                    {chargeValueTypeEnum === 1 && (
                      <TextInput
                        formatter={formatCurrency}
                        label="charge value"
                        onChange={(e: any) =>
                          updateTierChargeField('currency', index, e)
                        }
                        value={scd[2] ? formatCurrency(scd[2]) : ''}
                        style={{
                          marginTop: '0.23rem',
                          marginBottom: '0.25rem'
                        }}
                      />
                    )}
                  </div>
                  <div>
                    <Icons.DeleteIcon
                      onClick={() => deleteSteppedCharge(index)}
                    />
                  </div>
                </>
              ) : (
                <Grid
                  container
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Grid item xs={7}>
                    {getRangeString(toValue, fromValue)}
                  </Grid>
                  <Grid item xs={5}>
                    {chargeValueTypeEnum === 1
                      ? formatCurrency(scd[2])
                      : formatPercent(scd[2])}
                  </Grid>
                </Grid>
              )}
            </div>
          );
        })}
        <div style={{ marginTop: '1rem' }}>
          <Button onClick={addSteppedCharge}>Add Tier</Button>
        </div>
      </>
      <div style={{ display: 'none' }}>
        <Button
          id="platformProviderChargesSubmit"
          onClick={() =>
            save(
              tieredChargeData,
              currentTieredChargeData,
              currentPolicyTypes,
              aumRangeFrom,
              aumRangeTo,
              chargeValueTypeEnum,
              isFamilyLinked,
              selectedPlatformType,
              selectedProviderType,
              'tiered_charge',
              platformIndex,
              updateCharge,
              checkForm
            )
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default TieredCharge;
